import moment from "moment/moment";
import Logo from "../../assets/c2c_logo.png";

export const convertToBooleanHelper = (obj) => {
  return convertStringToBoolean(obj);
};

export const convertStringToBoolean = (obj) => {
  if (obj) {
    Object.keys(obj).forEach((key) => {
      obj[key] =
        typeof obj[key] === "object"
          ? convertStringToBoolean(obj[key])
          : obj[key] === "true" || obj[key] === "True"
          ? true
          : obj[key] === "False" || obj[key] === "false"
          ? false
          : obj[key];
    });
    return obj;
  }
};

export const getReceiptHeaderData = (pdfData) => {
  pdfData.payload_reciept.INVOICE_DATE = pdfData?.payload_reciept?.INVOICE_DATE
    ? moment(pdfData.payload_reciept.INVOICE_DATE).format("DD MMMM YYYY")
    : "";

  if (
    pdfData.payload_reciept.PARTIAL_AMOUNT_DETAILS &&
    pdfData.payload_reciept.PARTIAL_AMOUNT_DETAILS?.amount
  ) {
    pdfData.payload_reciept["displayPartialAmountDetails"] = true;
    pdfData.payload_reciept.PARTIAL_AMOUNT_DETAILS.date = moment(
      pdfData.payload_reciept.PARTIAL_AMOUNT_DETAILS.date
    ).format("DD MMM YYYY");
  } else {
    pdfData.payload_reciept["displayPartialAmountDetails"] = false;
  }

  if (pdfData.payload_reciept.multiple_payment_methods_details?.length !== 0) {
    pdfData.payload_reciept["displayMultiplePaymentMethods"] = true;
    let multiPaymentArr = [];
    pdfData.payload_reciept.multiple_payment_methods_details.forEach((ele) => {
      if (ele.payment_method === "Refund") {
        if (ele.amount !== 0) {
          multiPaymentArr.push({
            ...ele,
            date: moment(ele.date).format("DD MMM YYYY"),
          });
        }
      } else {
        multiPaymentArr.push({
          ...ele,
          date: moment(ele.date).format("DD MMM YYYY"),
        });
      }
    });
    pdfData.payload_reciept.multiple_payment_methods_details = multiPaymentArr;
  } else {
    pdfData.payload_reciept["displayMultiplePaymentMethods"] = false;
  }

  if (pdfData.payload_reciept.CONSULTATION_FEE_DETAILS_LIST?.length > 0) {
    let hasPartialAmount;
    if (
      pdfData.payload_reciept.PARTIAL_AMOUNT_DETAILS &&
      pdfData.payload_reciept.PARTIAL_AMOUNT_DETAILS?.amount
    ) {
      hasPartialAmount = true;
    } else {
      hasPartialAmount = false;
    }
    pdfData.payload_reciept.CONSULTATION_FEE_DETAILS_LIST.map(
      (tableData) => (tableData["showPartialAmount"] = hasPartialAmount)
    );
  }
  return pdfData;
};

export const getReceiptFooterData = (pdfData) => {
  let receiptData = pdfData?.payload_reciept;
  let c2cLogo = Logo;
  let receiptFooterData = {
    showFooter: false,
    c2cLogo: c2cLogo,
    showC2CLogo: true,
    created_by: receiptData?.created_by,
  };

  let is_clinic_found = false;

  if (receiptData?.custom_margins_enabled) {
    receiptFooterData.showFooter = false;
  } else {
    receiptFooterData.showFooter = true;
    if (
      (receiptData?.HOSPITAL_DATA &&
        receiptData?.HOSPITAL_DATA?.show_hospital_footer === true) ||
      (receiptData?.HOSPITAL_DATA && receiptData?.preview)
    ) {
      let hospitalDetails = receiptData?.HOSPITAL_DATA;
      let hospitalLogo = null;
      if (hospitalDetails && hospitalDetails !== null) {
        let detail = hospitalDetails;
        hospitalLogo = detail?.hospital_logo_path;
        hospitalDetails.hospital_contact_number =
          hospitalDetails &&
          hospitalDetails?.hospital_contact_number &&
          !hospitalDetails?.hospital_contact_number?.startsWith("+91")
            ? "+91" + hospitalDetails?.hospital_contact_number
            : "";
      }

      if (
        (hospitalDetails?.is_hospital_name_enabled &&
          hospitalDetails?.hospital_name) ||
        (hospitalDetails?.is_hospital_logo_enabled &&
          hospitalDetails?.hospital_logo_path) ||
        (hospitalDetails?.is_hospital_contact_no_enabled &&
          hospitalDetails?.hospital_contact_number) ||
        (hospitalDetails?.is_hospital_address_enabled &&
          hospitalDetails?.hospital_address)
      ) {
        is_clinic_found = true;
      } else {
        is_clinic_found = false;
      }
      let showHospitalFound = receiptData?.preview
        ? true
        : receiptData?.HOSPITAL_DATA?.show_hospital_footer;
      let footerData = {
        showC2CLogo: !is_clinic_found || !showHospitalFound ? true : false,
        c2cLogo: c2cLogo,
        doctor_full_name: receiptData?.DOCTOR_FULL_NAME,
        doctor_hospital_details: hospitalDetails,
        hospitalLogo: hospitalLogo,
        is_hospital_logo_enabled: hospitalDetails?.is_hospital_logo_enabled,
        show_hospital_footer: showHospitalFound,
        is_clinic_found: is_clinic_found,
        custom_margin_dimensions: receiptData?.custom_margin_dimensions,
      };
      receiptFooterData = { ...receiptFooterData, ...footerData };
    } else if (
      receiptData?.HOSPITAL_DATA &&
      receiptData?.HOSPITAL_DATA.length > 0
    ) {
      let hospitalDetails = receiptData?.HOSPITAL_DATA;
      let hospitalLogo = null;
      let is_hospital_logo_enabled = false;
      if (hospitalDetails.length > 0) {
        let detail = hospitalDetails.filter(
          (d) =>
            d?.is_hospital_logo_enabled && d?.hospital_logo?.presigned_url_view
        );
        detail = detail.length ? detail[0] : null;
        is_hospital_logo_enabled =
          detail && detail.is_hospital_logo_enabled ? true : false;
        hospitalLogo = detail?.hospital_logo?.presigned_url_view;
        hospitalDetails = hospitalDetails.filter(
          (detail) =>
            (detail?.is_hospital_name_enabled && detail?.hospital_name) ||
            (detail?.is_hospital_address_enabled && detail?.hospital_address) ||
            (detail?.is_hospital_contact_no_enabled &&
              detail?.hospital_contact_number) ||
            (detail?.is_hospital_timings_enabled && detail?.hospital_timings)
        );

        hospitalDetails.forEach((detail, index) => {
          detail.hospital_contact_number =
            !detail?.hospital_contact_number?.startsWith("+91") &&
            detail?.hospital_contact_number?.length === 10
              ? "+91" + detail.hospital_contact_number
              : "";

          detail.index = index + 1;
        });
        let found = hospitalDetails.some(
          (el) =>
            el.is_hospital_name_enabled === true ||
            el.is_hospital_logo_enabled === true ||
            el.is_hospital_address_enabled === true ||
            el.is_hospital_contact_no_enabled === true ||
            el.is_hospital_timings_enabled === true
        );
        if (found) {
          is_clinic_found = true;
        } else {
          is_clinic_found = false;
        }
      }

      let footerData = {
        showC2CLogo:
          !is_clinic_found ||
          !receiptData?.is_default_c2c_footer_to_be_shown_in_receipt
            ? true
            : false,
        c2cLogo: c2cLogo,
        doctor_full_name: receiptData?.DOCTOR_FULL_NAME,
        doctor_hospital_details: hospitalDetails,
        hospitalLogo: hospitalLogo,
        is_hospital_logo_enabled: is_hospital_logo_enabled,
        is_default_c2c_footer_to_be_shown_in_receipt:
          receiptData?.is_default_c2c_footer_to_be_shown_in_receipt,
        is_clinic_found: is_clinic_found,
        custom_margin_dimensions: receiptData?.custom_margin_dimensions,
      };
      receiptFooterData = { ...receiptFooterData, ...footerData };
    } else {
      let footerData = {
        showC2CLogo: true,
        dummy_doctor_flag: receiptData?.dummy_doctor_flag,
        c2cLogo: c2cLogo,
        doctor_full_name: receiptData?.DOCTOR_FULL_NAME,
        is_clinic_found: false,
        custom_margin_dimensions: receiptData?.custom_margin_dimensions,
      };
      receiptFooterData = { ...receiptFooterData, ...footerData };
    }
  }
  receiptData["receiptFooterData"] = receiptFooterData;
  return pdfData;
};
